module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_5012.eedf2f12.png";